import { API_GET_USER, API_USERS } from "../constants";

const state = {
    user : {
        id: '',
        name: '',
        email: '',
        phone: '',
        role: [],
        avatar_path: ''
    },
    allUsers: []
}
const mutations = {
    SET_USER : (state, payload) => {
        window.localStorage.setItem('user', JSON.stringify(payload));
        state.user = payload
    },
    SET_ALL_USERS(state, payload) {
        state.allUsers = payload
    }
}
const getters = {
    USER : state => {
        return state.user;
    },
    allUsers: state => state.allUsers
}
const actions = {
    GET_USER : async (context, payload) => {
        const response = await api.call('get', API_GET_USER)
        context.commit('SET_USER', response.data)
    },
    UPDATE_USER(context, payload) {
        context.commit('SET_USER', payload)
    },
    GET_USERS({ commit }) {
        axios.get(API_USERS, {
            params: {
                roles: 'administrator||sales-head-manager||sales-manager||logistics-head-manager||logistics-manager||logistics-multim-manager||logistics-multim-head-manager||TO-head-manager||TO-manager||accountant||head-accountant||president||declarant-head-manager||declarant-manager||bsz-manager||b2c-head-manager||b2c-manager||lawyer-manager||lawyer-head-manager||hr-manager||hr-head-manager||agent'
            }
        }).then(({ data }) => {
            commit('SET_ALL_USERS', data)
        })
    }
}

export default {
    state, getters, mutations, actions
}
